import type { ComboboxItem } from '@mantine/core';
import dayjs from 'dayjs';
import type { WorkPeriod } from '../../../../api/work-periods-client/work-periods-client.type';
import { safeParseDateInput } from '../../../../helpers/date-time-helpers';

/**
 * Transforms work periods into select options for the sprint multiselect.
 * Filters to show only completed sprints and sorts them by start date (most recent first).
 *
 * @param workPeriods - Array of work periods to transform
 * @returns Array of ComboboxItem objects for the select component
 */
function getCompletedSprintOptions(workPeriods: WorkPeriod[] | undefined): ComboboxItem[] {
  if (!workPeriods) {
    return [];
  }

  return workPeriods
    .filter((wp) => safeParseDateInput(wp.end_date)?.isBefore(dayjs()) === true)
    .sort((a, b) => {
      // Defensively parse dates with fallback to 0 to avoid NaN in sort comparison
      const aTime = safeParseDateInput(a.start_date)?.unix() ?? 0;
      const bTime = safeParseDateInput(b.start_date)?.unix() ?? 0;
      return bTime - aTime; // Most recent first
    })
    .map((wp) => ({
      value: wp.id,
      label: wp.name,
    }));
}

export { getCompletedSprintOptions };
